import {endpoint} from 'services/Api';
import {RESOURCE as PARENT} from 'services/api/dashboards';

/**
 * Resource Endpoint.
 *
 * @type {String}
 */
const RESOURCE = 'reserving';

/**
 * Reserves Dashboard Endpoints:
 *     - overview
 */
export default {
    /**
     * Day One Assessment data
     *
     * @return {Promise}
     */
    dayOneAssessment: (data) => endpoint(`${PARENT}/${RESOURCE}`, 'advanced-assessment', data),

    /**
     * Average Reserves data
     *
     * @return {Promise}
     */
    averageReserves: (data) => endpoint(`${PARENT}/${RESOURCE}`, 'average', {
        disease_type: data.diseaseType,
    }),

    /**
     * Day one assesment
     *
     * @param claim
     * @param person
     */
    simpleAssessment: (claim, person) => endpoint(`${PARENT}/${RESOURCE}`, 'simple-assessment', {claim, person}),

    /**
     * Get compare results.
     *
     * @param {string} injuryType
     * @param {string} claimType
     * @param {number} discountRate
     * @param {string} from
     * @param {string} to
     */
    compareAssessment: (diseaseOrAccident, injuryType, claimType, discountRate, from, to) => {
        return endpoint(`${PARENT}/${RESOURCE}`, 'compare', {diseaseOrAccident, injuryType, claimType, discountRate, from, to, type:null});
    }
};



// WEBPACK FOOTER //
// ./src/services/api/dashboards/reserving.js